import { BatteryOutlineIcon } from './BatteryOutlineIcon';

/**
 * author: Google
 * id 925B02B4-CA05-4545-A4E3-421F8412DA37
 * name battery-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-outline.svg
 * tags
 * - Battery 
 * - Home Automation 
 * - Automotive 
 */
export const BatteryEmptyIcon = BatteryOutlineIcon;
export default BatteryEmptyIcon